'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _streamUrlUtil = require('./streamUrlUtil');

var _streamUrlUtil2 = _interopRequireDefault(_streamUrlUtil);

var _debugger = require('./debugger');

var _debugger2 = _interopRequireDefault(_debugger);

var _tuner = require('./tuner');

var _tuner2 = _interopRequireDefault(_tuner);

var _deferredPromise = require('./utils/deferredPromise');

var _deferredPromise2 = _interopRequireDefault(_deferredPromise);

var _cancelable = require('./utils/cancelable');

var _cancelable2 = _interopRequireDefault(_cancelable);

var _getMasterManifestUrl = require('./utils/getMasterManifestUrl');

var _getMasterManifestUrl2 = _interopRequireDefault(_getMasterManifestUrl);

var _mediaFormats = require('./player/constants/mediaFormats');

var _mediaFormats2 = _interopRequireDefault(_mediaFormats);

var _playerName = require('./player/constants/playerName');

var _playerName2 = _interopRequireDefault(_playerName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currentStream = void 0;
var processedDeferred = void 0;
var streamPlayerPromise = void 0;
var masterManifestFetchPromise = void 0;
var defaultShoutcastExtraTimeout = 10000; // default - should be derived from config

function onSuccess(connectionData) {
  _debugger2.default.log('playing');

  processedDeferred.resolve(connectionData);
}

function onFailure(err) {
  _debugger2.default.log('failed', err);

  processedDeferred.reject(err);
}

function attemptPlayback(playbackConfig) {
  // TODO: remove if statement after manifest fetching logic is moved from process() below to
  //  InstreamAdPlayer
  if (!currentStream.isHlsAdvanced) {
    _tuner2.default.trigger(_tuner2.default.events.attemptingPlayback);
  }

  return (0, _cancelable2.default)(_tuner2.default.streamPlayer.attemptPlayback(playbackConfig));
}

function attemptShoutcastStream(err) {
  var shoutcastUrl = _streamUrlUtil2.default.shoutcastStreamUrl(currentStream.url);

  if (shoutcastUrl !== currentStream.url) {
    currentStream.url = shoutcastUrl;
    currentStream.isShoutcastHack = true;

    _debugger2.default.log('attempting shoutcast', currentStream);

    var playbackConfig = {
      stream: currentStream,
      ignoreStreamPosition: false,
      additionalTimeout: currentStream.isFinalStream && (_tuner2.default.shoutcastExtraTimeout || defaultShoutcastExtraTimeout)
    };
    var cancelablePromise = attemptPlayback(playbackConfig);

    cancelablePromise.then(onSuccess).catch(function (error) {
      // if the test stream fails, clear media so requests don't hang
      if (_tuner2.default.tune.testStreamUrl && currentStream.isFinalStream) {
        _tuner2.default.streamPlayer.clearMedia();
      }

      onFailure(error);
    });

    streamPlayerPromise = cancelablePromise;
  } else {
    onFailure(err);
  }
}

exports.default = {
  process: function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(stream) {
      var originalUrl, playbackConfig, _ref2, trackingUrl, manifestUrl;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              originalUrl = stream.url;


              currentStream = stream;

              // Apply sanitization routines if allowed to do so
              if (stream.format !== _mediaFormats2.default.hls) {
                // If the stream's configured format is not hls, but the stream url has an hls
                // extension, then we need to report this stream url so that we can get the format
                // updated correctly.
                if (_streamUrlUtil2.default.isHLS(currentStream.url)) {
                  currentStream.isHlsFormatIncorrect = true;
                }
                // If the url is a .m3u, remove the extension and indicate the stream had the .m3u hack
                // applied for logging purposes
                currentStream.url = _streamUrlUtil2.default.removeM3UExtension(currentStream.url);
                if (originalUrl !== currentStream.url) {
                  currentStream.removedM3UExtension = true;
                }
              }

              processedDeferred = (0, _deferredPromise2.default)();

              if (!stream.forceShoutcast) {
                _context.next = 8;
                break;
              }

              attemptShoutcastStream(null);
              _context.next = 23;
              break;

            case 8:
              _debugger2.default.log('attempting playback', currentStream);

              playbackConfig = {
                stream: currentStream,
                ignoreStreamPosition: _tuner2.default.tune.ignoreStreamPosition,
                playFromPosition: _tuner2.default.tune.playFromPosition,
                liveSeekStreamPosition: _tuner2.default.tune.liveSeekStreamPosition
              };

              if (!currentStream.isHlsAdvanced) {
                _context.next = 21;
                break;
              }

              // TODO: move this if-statement logic to HLS player load method.
              //  The arbitrary emitting of `attemptingPlayback` and `playerSelected` below can be
              //  removed after that, since StreamPlayer will have already emitted the event before any
              //  media is loaded
              _tuner2.default.trigger(_tuner2.default.events.attemptingPlayback);
              _tuner2.default.trigger(_tuner2.default.events.playerSelected, _playerName2.default.InstreamAdPlayer);
              masterManifestFetchPromise = (0, _cancelable2.default)((0, _getMasterManifestUrl2.default)(currentStream.url));
              _context.next = 16;
              return masterManifestFetchPromise;

            case 16:
              _ref2 = _context.sent;
              trackingUrl = _ref2.trackingUrl;
              manifestUrl = _ref2.manifestUrl;


              currentStream.url = manifestUrl;
              playbackConfig.instreamTrackingUrl = trackingUrl;

            case 21:

              streamPlayerPromise = attemptPlayback(playbackConfig);

              // chaining separately so that streamPlayerPromise retains references to cancelable API
              streamPlayerPromise.then(onSuccess).catch(function (err) {
                return attemptShoutcastStream(err);
              });

            case 23:
              return _context.abrupt('return', processedDeferred.promise);

            case 24:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function process(_x) {
      return _ref.apply(this, arguments);
    }

    return process;
  }(),
  cancel: function cancel() {
    _tuner2.default.streamPlayer.clearTimeout();

    if (masterManifestFetchPromise) masterManifestFetchPromise.cancel();
    if (streamPlayerPromise) streamPlayerPromise.cancel();
    if (processedDeferred) processedDeferred.promise.cancel();
  }
};
//# sourceMappingURL=streamProcessor.js.map